import React from 'react';
import { useIntl } from 'react-intl';
import { Col, Container, Row } from 'reactstrap';
import { nextAsset } from '../../../../components/nextAsset';

export const SmartlinksLinkfireAlternativeWhyBest: React.FC = () => {
  const intl = useIntl();

  return (
    <div className="bg-primary-dark">
      <Container className="py-5 text-white">
        <Row className="align-items-center">
          <Col xs={12} lg={6} className="order-lg-2">
            <img
              src={nextAsset(`images/smartLinks/alternative/why-smart-links-is-the-best.png`, false, { w: 900 })}
              alt=""
              className="img-fluid"
            />
          </Col>
          <Col xs={12} lg={6} className="py-5">
            <p className="main-header">
              {intl.formatMessage({
                id: 'sml.web.smart-links.linkfire_alternative.alternative.title',
                defaultMessage: 'Why Music24 is the best Linkfire alternative'
              })}
              &nbsp;🏆
            </p>
            <p className="fs-4">
              {intl.formatMessage(
                {
                  id: 'sml.web.smart-links.linkfire_alternative.alternative.description',
                  defaultMessage:
                    'Although Linkfire was the first smart link aggregator designed for the music industry, you may be wondering if there is a better and cheaper alternative to having smart links for your music marketing. {br}{br} And the answer is <u>YES</u>. {br}{br} Music24 offers a modern, powerful Linkfire alternative for sharing music links, social media, videos and more.'
                },
                {
                  br: <br />,
                  u: (children) => <u>{children}</u>
                }
              )}
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
